import React from 'react'
import { Route, Switch } from 'react-router'

import Login from "../Login";

import ProfileSAdmin from "../ProfileSAdmin";

import Profile from "../User/Profile";
import CreateUser from "../User/CreateUser";
import BulkCreateUser from "../User/BulkCreateUser";
import EditUser from "../User/EditUser";
import ChangePassword from "../ChangePassword";

import ListUsers from "../User/ListUsers";

import CreateClient from "../Tenant/CreateClient";
import EditClient from "../Tenant/EditClient";
import ProfileClient from "../Tenant/ProfileClient";
import ListClients from "../Tenant/ListClients";

import ManagePermissions from "../ManagePermissions";
import ManageProducts from "../ManageProducts";
import ConfirmEmail from '../ConfirmEmail';
import ForgotPassword from '../ForgotPassword';
import ResetPassword from '../ResetPassword';
import NotFound from '../../components/Templates/Site/NotFound';

import SSOListener from '../SSOListener';
import WhitePage from '../../components/Templates/Site/WhitePage';
import Logout from '../Login/Logout';
import { useSelector } from 'react-redux';
import { isNullOrUndefined } from '../../common/Helpers';

export function Pages() {
    const { user: currentAuth } = useSelector((state) => state.auth);
    
    return (
        <Switch>
            <Route exact path={["/", '/login']} component={Login} />
            <Route exact path="/logout" component={Logout} />

            <Route exact path="/profile" component={Profile} />
            <Route exact path="/edituser" component={EditUser} />

            <Route exact path='/confirmemail' component={ConfirmEmail} />
            <Route exact path='/forgotpassword' component={ForgotPassword} />
            <Route exact path='/changepassword' component={ChangePassword} />
            <Route exact path='/resetpassword' component={ResetPassword} />
            <Route exact path='/ssolistener' component={SSOListener} />
            <Route exact path='/whitepage' component={WhitePage} />

            {
                currentAuth && !isNullOrUndefined(currentAuth.profile.find(x => x === "sAdmin")) &&
                <>
                    <Route exact path="/createuser" component={CreateUser} />
                    <Route exact path="/bulkcreateuser" component={BulkCreateUser} />
                    <Route exact path="/createclient" component={CreateClient} />
                    <Route exact path="/editclient" component={EditClient} />
                    <Route exact path="/profileclient" component={ProfileClient} />
                    <Route exact path="/listclients" component={ListClients} />
                    <Route exact path="/listusers" component={ListUsers} />
                    <Route exact path="/profilesadmin" component={ProfileSAdmin} />
                    <Route exact path="/managepermissions" component={ManagePermissions} />
                    <Route exact path="/manageproducts" component={ManageProducts} />
                </>
            }
            {
                currentAuth && !isNullOrUndefined(currentAuth.profile.find(x => x === "Admin")) &&
                <>
                    <Route exact path="/createuser" component={CreateUser} />
                    <Route exact path="/bulkcreateuser" component={BulkCreateUser} />
                    <Route exact path="/profileclient" component={ProfileClient} />
                    <Route exact path="/listusers" component={ListUsers} />
                    <Route exact path="/managepermissions" component={ManagePermissions} />

                    <Route exact path="/createclient" component={NotFound} />
                    <Route exact path="/editclient" component={NotFound} />
                    <Route exact path="/listclients" component={NotFound} />
                    <Route exact path="/profilesadmin" component={NotFound} />
                    <Route exact path="/manageproducts" component={NotFound} />
                </>
            }

            <Route component={NotFound} />
        </Switch>
    )
}
